import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

const salsify = getServiceProvider('salsify');

export default createServiceProvider({
  ...salsify,
  requiresOAuthFlow: false,
  avatarPath: avatars.salsify,
  logoPath: logos.salsify
});
